const navigationFooter = document.querySelector('.navigationFooter')
const navPointsFooter = navigationFooter.querySelectorAll('a')


const getFooterState = (item) => {
    const pathnames = location.pathname.split('/').slice(1)
    const pathKey = item.getAttribute('data-name')
    const isActive = pathnames.includes(pathKey)

    if(isActive) {
        item.parentElement.classList.add('active')
    }
}

navPointsFooter.forEach(item => {
    getFooterState(item);
})
